import React from 'react';
import Container from '../interface/Container';
import BlockWrapper from './BlockWrapper';
import Accordion from '../Accordion/Accordion';

const AccordionBlock = ({ block }) => {
  return (
    <BlockWrapper grayBackground>
      <Container>
        <Accordion mainTitle={block?.mainTitle} items={block?.items} />
      </Container>
    </BlockWrapper>
  );
};

export default AccordionBlock;
